import script from "./ContrastAccessibilityPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ContrastAccessibilityPanel.vue?vue&type=script&setup=true&lang=js"

import "./ContrastAccessibilityPanel.vue?vue&type=style&index=0&id=2283b675&lang=css"

const __exports__ = script;

export default __exports__